import styled from 'styled-components';
import { SwitchProps } from '.';

export const Input = styled.input<Omit<SwitchProps, 'onChange'>>`
	opacity: 0;
	height: 0;
	width: 0;
	display: inline;
	overflow: hidden;
	position: absolute;
	pointer-events: none;
	transition: all 0.15s ease-out;

	&:checked + label div {
		background: ${({ theme, checkedBackground }) => checkedBackground ?? '#673BA0' ?? '#7652b2'};

		&::after {
			transform: translateX(20px);
		}
	}
`;

export const Label = styled.label<Pick<SwitchProps, 'fontWeight' | 'fontSize' | 'fontColor'>>`
	cursor: pointer;
	display: flex;
	align-items: center;
	font-weight: ${({ theme, fontWeight }) => fontWeight ?? theme.fontWeight.bold ?? 700};
	font-size: ${({ fontSize }) => fontSize ?? 17}px;
	color: ${({ theme, fontColor }) => fontColor ?? theme.colors.text1 ?? 'black'};
`;

export const CheckTumb = styled.div<Pick<SwitchProps, 'background' | 'color'>>`
	position: relative;
	margin-left: auto;
	display: block;
	height: 31px;
	min-width: 51px;
	border-radius: 50px;
	background-color: ${({ theme, background }) => background ?? theme.colors.bg5 ?? '#d9d9d9'};
	transition: all 0.15s ease-out;

	&::after {
		content: '';
		width: 27px;
		height: 27px;
		background-color: white;
		border-radius: 50px;
		position: absolute;
		top: 2px;
		left: 2px;
		transition: all 0.15s ease-out;
	}
`;
